import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Facebook, Linkedin, Twitter } from "lucide-react";
import { SOCIAL_LINKS, PHONE_NUMBER, PHONE_TEL, CONTACT_EMAIL, LEGAL_ENTITY } from "../../config/siteConfig";

const socialItems = [
  { id: "instagram", href: SOCIAL_LINKS.instagram, label: "Instagram", Icon: Instagram },
  { id: "x", href: SOCIAL_LINKS.x, label: "X (Twitter)", Icon: Twitter },
  { id: "facebook", href: SOCIAL_LINKS.facebook, label: "Facebook", Icon: Facebook },
  { id: "youtube", href: SOCIAL_LINKS.youtube, label: "YouTube", Icon: Youtube },
  { id: "linkedin", href: SOCIAL_LINKS.linkedin, label: "LinkedIn", Icon: Linkedin },
];

export const HomeFooter = () => (
  <footer className="border-t border-white/10 py-12 bg-slate-900/50">
    <div className="mx-auto max-w-7xl px-6">
      <div className="grid md:grid-cols-4 gap-8 mb-8">
        <div>
          <div className="text-lg font-semibold mb-4">Social Dispute Co</div>
          <p className="text-slate-400 text-sm leading-relaxed mb-4">
            Professional appeal documentation for suspended, disabled, and restricted social media accounts.
          </p>
          <div className="flex items-center gap-3" aria-label="Social media">
            {socialItems.map(({ id, href, label, Icon }) => (
              <a
                key={id}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                data-testid={`footer-social-${id}`}
                className="w-9 h-9 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center text-slate-300 hover:text-white transition"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <div className="font-semibold mb-4">Services</div>
          <div className="flex flex-col gap-2 text-sm text-slate-400">
            <Link to="/pricing" className="hover:text-white transition-colors">Pricing</Link>
            <Link to="/contact" className="hover:text-white transition-colors">Free Assessment</Link>
            <Link to="/analyze" className="hover:text-white transition-colors">Suspension Analyzer</Link>
            <Link to="/faq" className="hover:text-white transition-colors">FAQ</Link>
          </div>
        </div>

        <div>
          <div className="font-semibold mb-4">Legal</div>
          <div className="flex flex-col gap-2 text-sm text-slate-400">
            <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link>
            <Link to="/refund-policy" className="hover:text-white transition-colors">Refund Policy</Link>
            <Link to="/disclaimer" className="hover:text-white transition-colors">Disclaimer</Link>
          </div>
        </div>

        <div>
          <div className="font-semibold mb-4">Contact</div>
          <div className="flex flex-col gap-2 text-sm text-slate-400">
            <a href={PHONE_TEL} className="hover:text-white transition-colors">{PHONE_NUMBER}</a>
            <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-white transition-colors">{CONTACT_EMAIL}</a>
            <Link to="/trust" className="hover:text-white transition-colors">Verify Our Business</Link>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 pt-8 text-center">
        <p className="text-slate-400 text-sm">
          {LEGAL_ENTITY.dba} is a registered trade name of {LEGAL_ENTITY.llc}
        </p>
        <p className="text-slate-500 text-sm mt-1">
          {LEGAL_ENTITY.city}, {LEGAL_ENTITY.state} | {LEGAL_ENTITY.country} | {CONTACT_EMAIL}
        </p>
        <p className="text-slate-500 text-sm mt-4">
          © {new Date().getFullYear()} {LEGAL_ENTITY.llc}. All rights reserved.
        </p>
        <p className="text-slate-600 text-xs mt-4 max-w-2xl mx-auto">
          Social Dispute Co is an independent service and is not affiliated with Meta, Instagram,
          Facebook, TikTok, YouTube, X, or any social media platform. We do not guarantee outcomes.
        </p>
      </div>
    </div>
  </footer>
);
